"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var types_1 = require("../types");
var animateOut = function (position) {
    switch (position) {
        case 'topCenter':
        case 'bottomCenter':
            return dissmissFadeOut;
        case 'topLeft':
        case 'bottomLeft':
            return dismissLeft;
        case 'topRight':
        case 'bottomRight':
        default:
            return dismissRight;
    }
};
var getLeftAndCenterPositions = function (position) {
    switch (position) {
        case 'topCenter':
        case 'bottomCenter':
            return '50%';
        case 'topLeft':
        case 'bottomLeft':
            return '12px';
        default:
            return null;
    }
};
var getAlignment = function (position) {
    if (position.includes('Left')) {
        return 'flex-start';
    }
    if (position.includes('Center')) {
        return 'center';
    }
    return 'flex-end';
};
var isFaded = function (animationType) { return animationType === types_1.EAnimationType.fade; };
exports.SnackbarContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  position: fixed;\n  z-index: 99999;\n  ", "\n\n  .remove-snack {\n    ", "\n  }\n  ", "\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  position: fixed;\n  z-index: 99999;\n  ", "\n\n  .remove-snack {\n    ", "\n  }\n  ", "\n  ", "\n\n  ", "\n"])), function (_a) {
    var position = _a.position;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: ", ";\n    flex-direction: ", ";\n    top: ", ";\n    bottom: ", ";\n    right: ", ";\n    left: ", ";\n    transform: ", ";\n  "], ["\n    align-items: ", ";\n    flex-direction: ", ";\n    top: ", ";\n    bottom: ", ";\n    right: ", ";\n    left: ", ";\n    transform: ", ";\n  "])), getAlignment(position), position.includes('bottom') ? 'column-reverse' : 'column', position.includes('top') ? '24px' : null, position.includes('bottom') ? '1rem' : null, position.includes('Right') ? '12px' : null, getLeftAndCenterPositions(position), position.includes('Center') ? 'translate(-50%, 0)' : null);
}, function (_a) {
    var animationType = _a.animationType, position = _a.position;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      animation: ", " ease-out forwards\n        ", ";\n    "], ["\n      animation: ", " ease-out forwards\n        ", ";\n    "])), isFaded(animationType) ? '700ms' : '250ms', isFaded(animationType) ? dissmissFadeOut : animateOut(position));
}, function (p) {
    return p.theme.mobileSm.only((0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: red;\n    "], ["\n      color: red;\n    "]))));
}, function (p) {
    return p.theme.mobileXs.only((0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: yellow;\n    "], ["\n      color: yellow;\n    "]))));
}, function (p) {
    return p.theme.mobileSm.max((0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      right: 8px;\n      left: 8px;\n      top: ", ";\n    "], ["\n      right: 8px;\n      left: 8px;\n      top: ", ";\n    "])), p.position.includes('top') ? '64px' : null));
});
/* *****KEYFRAMES**** */
var dissmissFadeOut = (0, styled_components_1.keyframes)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n   from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n"], ["\n   from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n"])));
var dismissLeft = (0, styled_components_1.keyframes)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n   from {\n    opacity: 1;\n  }\n  to {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n"], ["\n   from {\n    opacity: 1;\n  }\n  to {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n"])));
var dismissRight = (0, styled_components_1.keyframes)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n   from {\n    opacity: 1;\n  }\n  to {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n"], ["\n   from {\n    opacity: 1;\n  }\n  to {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
